<div class="container">
  <p class="title">Outras informações</p>
  <div class="row">
    <div class="col-1">
      <app-input 
        class="input-control" id="number_name_tower"
        label="Total de unidades por andar"
        type="number"
        max="100"
        placeholder=""
        (input)="removeCaracter($event)">
      </app-input>
    </div>
    <div class="col-2">
      <app-select
        labelText="Faces"
        height="110"
        field="name"
        sizeList="3"
        [disabled]="!dropdownOptions.length"
        [listItems]="dropdownOptions">
      </app-select>
    </div>
    <div class="col-3">
      <app-input 
        class="input-control" id="number_name_tower"
        label="Quantidade de andares"
        type="number"
        max="100"
        placeholder=""
        (input)="removeCaracter($event)">
      </app-input>
    </div>
  </div>
</div>